// extracted by mini-css-extract-plugin
export default {"banner":"vJa7uz","item":"KRAhzA","itemPlacementModal":"X8S3aK"};